var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "darkstore-factoid",
    attrs: {
      "href": _vm.darkstoreUrl
    }
  }, [_c('img', {
    staticClass: "darkstore-factoid__logo",
    attrs: {
      "src": require("./asset/darkstore-banner-logo.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "darkstore-factoid__slider"
  }, [_c('div', {
    staticClass: "darkstore-factoid__slider-barrier"
  }, [_c('div', {
    staticClass: "darkstore-factoid__slider-list"
  }, _vm._l(2, function (_, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _vm._m(6, true)]);
  }), 0)])]), _vm._v(" "), _c('img', {
    staticClass: "darkstore-factoid__mobile-img",
    attrs: {
      "src": require("./asset/darkstore-mobile.png"),
      "srcset": require("./asset/darkstore-mobile@2x.png") + " 2x",
      "alt": "Продукты"
    }
  }), _vm._v(" "), _vm._m(7)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "darkstore-factoid__title"
  }, [_vm._v("\n    Доставка продуктов"), _c('span', {
    staticClass: "darkstore-factoid__br"
  }), _vm._v(" по Каспийску\n    "), _c('span', {
    staticClass: "darkstore-factoid__br"
  }), _vm._v("\n    за 30 минут\n  ")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "darkstore-factoid__slider-item"
  }, [_c('img', {
    staticClass: "darkstore-factoid__slider-item-img",
    attrs: {
      "src": require("./asset/darkstore-slider-1.png"),
      "srcset": require("./asset/darkstore-slider-1@2x.png") + " 2x",
      "alt": "Продукты"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "darkstore-factoid__slider-item"
  }, [_c('img', {
    staticClass: "darkstore-factoid__slider-item-img",
    attrs: {
      "src": require("./asset/darkstore-slider-2.png"),
      "srcset": require("./asset/darkstore-slider-2@2x.png") + " 2x",
      "alt": "Продукты"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "darkstore-factoid__slider-item"
  }, [_c('img', {
    staticClass: "darkstore-factoid__slider-item-img",
    attrs: {
      "src": require("./asset/darkstore-slider-3.png"),
      "srcset": require("./asset/darkstore-slider-3@2x.png") + " 2x",
      "alt": "Продукты"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "darkstore-factoid__slider-item"
  }, [_c('img', {
    staticClass: "darkstore-factoid__slider-item-img",
    attrs: {
      "src": require("./asset/darkstore-slider-4.png"),
      "srcset": require("./asset/darkstore-slider-4@2x.png") + " 2x",
      "alt": "Продукты"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "darkstore-factoid__slider-item"
  }, [_c('img', {
    staticClass: "darkstore-factoid__slider-item-img",
    attrs: {
      "src": require("./asset/darkstore-slider-5.png"),
      "srcset": require("./asset/darkstore-slider-5@2x.png") + " 2x",
      "alt": "Продукты"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "darkstore-factoid__slider-item"
  }, [_c('img', {
    staticClass: "darkstore-factoid__slider-item-img",
    attrs: {
      "src": require("./asset/darkstore-slider-6.png"),
      "srcset": require("./asset/darkstore-slider-6@2x.png") + " 2x",
      "alt": "Продукты"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "darkstore-factoid__button cc-link cc-link_wu"
  }, [_c('button', {
    staticClass: "darkstore-factoid__button-el"
  }, [_vm._v("Перейти в даркстор")])]);
}]

export { render, staticRenderFns }